import { api, ApiRes } from './client'
import { CouponCode } from '../../typings'
import { AxiosRequestConfig } from 'axios'

interface AcceptedRisk {
    language: string
    risk_title: string
    risk_content: string
}

type ContractType = 'cash' | 'voucher'

interface OrderRequest {
    amount: string
    total_amount: string
    asset_uid: string
    asset_var_uid: string
    iban: string
    bic: string | null
    created_on: string
    ip_address: string
    additional_fields: any // Change 'any' to the appropriate type if known
    account_uid: string
    investor_consent: boolean
    first_name: string
    last_name: string
    incentive_uid: string
    agio_disagio: number
    agio_disagio_rate: number | null
    agio_disagio_disclaimer: string | null
    agio_disagio_title: string | null
    agio_disagio_type: number
    accepted_risks: AcceptedRisk[]
    contract_type: ContractType
    voucher_amount: number | null
    wallet_amount: number | null
}

export interface OrderResponseObject {
    order_uid: string
    account_uid: string
    asset_var_uid: string
    asset_uid: string
    platform_name: string
    incentive_uid: string
    natural_profile_id: string
    legal_profile_id: string | null
    amount: number
    total_amount: number
    total_amount_to_pay: number
    voucher_amount: number | null
    discount_voucher_amount: number | null
    wallet_amount: number | null
    agio_disagio: number
    agio_disagio_type: number
    agio_disagio_rate: number | null
    agio_disagio_title: string | null
    agio_disagio_disclaimer: string | null
    voucher_code: string | null
    voucher_rate: number | null
    reference_number: string
    broker: string
    account_title: string
    installments: number | null
    investor_consent: boolean
    status: number
    asset_data: AssetData
    company_logo: string
    company_logo_srcset: string
    created_on: string
    additional_fields: any[] // Change the type if you know the structure
    cancellation_date: string | null
    paid_date: string | null
    start_of_contract: string | null
    created_at: string
    updated_at: string
    contract_data_documents: Document[]
    reporting_documents: Document[]
    signature_manual: boolean
    signature_sproof: boolean
    has_signature: boolean
    emission_signatures: Signature[]
    needs_signature: boolean
    asset_signature_legal_notice: string | null
    payment_methods: {
        wire_transfer: boolean
        credit_card: boolean
    }
    credit_card_limit: number | null
    contract_interest_rate: number | null
    attachments: Document[]
}

interface AssetData {
    asset_title: string
    company_name: string
    company_logo: string | null
    agio_disagio: number
    agio_disagio_rate: number | null
    agio_disagio_type: number
    agio_disagio_title: string | null
    agio_disagio_disclaimer: string | null
    bic: string | null
    iban: string
    currency: string
    clearing_system: string
    step_level: number
    appropriateness_test_minimum_experience_and_knowledge: string | null
    appropriateness_test_minimum_experience_investment_services: string | null
}

interface Document {
    id: string
    name: string
    description: string | null
    url: string
    type: string
}

interface Signature {
    link: string
    type: string
    id: string
    unsigned_document_link: string
    document_type: string
    signed_at: string | null
    cancelled_at: string | null
}

interface OrderResponse {
    success: boolean
    order: OrderResponseObject
}

interface OrderValidateVoucherRequest {
    account_uid: string
    asset_var_uid: string
    voucher_code: string
    order_amount: number
}

type OrderValidateVoucherResponse = CouponCode

export const postOrder = (order: OrderRequest): ApiRes<OrderResponse> => api.post('orders', order)

export const postOrderValidateVoucher = (
    validateVoucherRequest: OrderValidateVoucherRequest
): ApiRes<OrderValidateVoucherResponse> => api.post('orders/validateVoucher', validateVoucherRequest)

export const getOrders = (account_uid: string): Promise<any> => {
    return api.get(`orders/accounts/${account_uid}`)
}

export const getOrder = (accountId: string, orderId: string): Promise<any> => {
    const config: AxiosRequestConfig = {}
    config.params = {}
    config.params.filter = {
        order_uid: orderId,
    }
    return api.get(`orders/accounts/${accountId}`, config)
}

export const showOrder = (orderId: string): Promise<any> => {
    return api.get(`orders/${orderId}`)
}
